import type { AppRouteRecordRaw } from "shared/types";

import lessonClassRoutes from "./lessonClass.routes";
import mentorClassRoutes from "./mentorClass.routes";

const routes: AppRouteRecordRaw[] = [
  ...mentorClassRoutes,
  ...lessonClassRoutes,
];

export default routes;
